import { useTranslation } from "react-i18next";

import { COMMUNICATION_RESULT_STATUSES } from "models";
import { Agreements, CommunicationEvents, Services, Signature } from "modules/AppointmentDetails/components/DeskCommunicationLog/components";
import { useAppointmentLocation } from "modules/AppointmentDetails/hooks";

import type { Appointment, DeskCommunication } from "models";

type ContentProps = {
  appointment: Appointment;
  comm: DeskCommunication;
};

export const Content = ({ comm }: ContentProps) => {
  const selectedLocation = useAppointmentLocation();
  const { t } = useTranslation();

  const { events, agreed_interventions, declined_interventions, results, agreements } = comm;

  const agreedQuestions = results?.filter(result => COMMUNICATION_RESULT_STATUSES.OkStatus === result.status);
  const declinedQuestions = results?.filter(result => result.status === COMMUNICATION_RESULT_STATUSES.NotOkStatus);

  return (
    <>
      <CommunicationEvents comm={comm} events={events} />
      <Services services={agreed_interventions} title={t("v8_accepted_scheduled_services", "Accepted scheduled services")} vat={selectedLocation?.vat} />
      <Services services={declined_interventions} title={t("v8_declined_scheduled_services", "Declined scheduled services")} vat={selectedLocation?.vat} />
      <Services services={agreedQuestions} title={t("v8_accepted_extra_services", "Accepted extra services")} vat={selectedLocation?.vat} />
      <Services services={declinedQuestions} title={t("v8_declined_extra_services", "Declined extra services")} vat={selectedLocation?.vat} />
      <Agreements agreements={agreements} />
      <Signature events={events} />
    </>
  );
};
